var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"employee",class:_vm.layout},[_c('Person',{attrs:{"content":_vm.person,"region":_vm.region,"images":_vm.image,"showIcons":_vm.showIcons,"layout":_vm.layout}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }